import React, { Suspense, lazy, useEffect, useState } from "react";
import { RouterProvider } from "react-router-dom";
import router from "../Router";
import Loader from "../Loader/Loader";
import LoginPopup from "../Form/LoginPopup";
const Header = lazy(() => import("../common-component/Header"));
const NewHeader = lazy(() => import("../common-component/NewHeader"));
const Footer = lazy(() => import("../common-component/Footer"));

const App: React.FC = () => {
  const [initialLoading, setInitialLoading] = useState(true);
  const isFirstLoad = sessionStorage.getItem("isFirstLoad");

  const currentPath = window.location.pathname;
  const isAuthPage = [
    "/vendor/login",
    "/vendor/signup",
    "/vendor/forget-password",
  ].includes(currentPath);
  const isHomePage = currentPath === "/";

  useEffect(() => {
    if (!isFirstLoad) {
      const timeout = setTimeout(() => {
        setInitialLoading(false);
        sessionStorage.setItem("isFirstLoad", "false");
      }, 1000);

      return () => clearTimeout(timeout);
    } else {
      setInitialLoading(false);
    }
  }, [isFirstLoad]);
  if (initialLoading) {
    return <Loader />;
  }

  return (
    <>
      {!isAuthPage && (
        <Suspense fallback={null}>
          {isHomePage ? <Header /> : <NewHeader />}
        </Suspense>
      )}
      <RouterProvider router={router} />
      <LoginPopup />
      {!isAuthPage && (
        <Suspense fallback={null}>
          <Footer />
        </Suspense>
      )}
    </>
  );
};

export default App;
